import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CrudService } from '../shared/grid/crud.service';
import { TaskAssignment, TaskAssignmentExposureContribution } from '../models/taskAssignment.model';

@Injectable({
    providedIn: 'root'
})
export class TaskAssignmentService extends CrudService<TaskAssignment> {

    constructor(http: HttpClient) {
        super('TaskAssignment', http);
    }

    getExposureContributions(sensorAssignmentId: string, analyteId: string) {
        return this.http.get<TaskAssignmentExposureContribution[]>(
            this.getApiUrl('TaskAssignment/GetExposureContributions'), {
            params: new HttpParams()
                .set('sensorAssignmentId', sensorAssignmentId)
                .set('analyteId', analyteId)
        });
    }
}